'use client';
import { getRequest } from '@/api/helpers';
import { routes } from '@/api/routes';
import BorderEdge from '@/components/common/border-edge';
import TestimonialsCarouselItem from '@/components/home/testimonial-carousel-item';
import Image from 'next/image';
import { useEffect, useState } from 'react';
import Slider from 'react-slick';

const UsaClientTrust = () => {
    const testimonialsettings = {
        dots: true,
        arrow: true,
        autoplay: true,
        infinite: true,
        speed: 500,
        slidesToShow: 2,
        slidesToScroll: 1,
        responsive: [
            { breakpoint: 1024, settings: { slidesToShow: 1, slidesToScroll: 1 } },
            { breakpoint: 600, settings: { slidesToShow: 1, slidesToScroll: 1 } },
            { breakpoint: 480, settings: { slidesToShow: 1, slidesToScroll: 1 } },
        ],
    };

    const [testimonialData, setTestimonialData] = useState<any[]>([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [currentVideo, setCurrentVideo] = useState('');

    useEffect(() => {
        fetchTestimonials();
    }, []);

    const fetchTestimonials = async () => {
        const response = await getRequest(routes.TESTIMONIALS);
        if (response && response.data.length > 0) {
            const data: any[] = [];
            response.data.forEach((testimonial: any) => {
                if (testimonial.image && testimonial.video_url) {
                    data.push({
                        id: testimonial.id,
                        image: testimonial.image,
                        video: testimonial.video_url,
                        project_name: testimonial.project_name,
                        client_name: testimonial.client_name,
                        description: testimonial.description,
                    });
                }
            });
            setTestimonialData(data);
        }
    };

    const handleClick = (videoSrc: string) => {
        const videoModal = document.getElementById('usaVideoModal');
        const videoElement = videoModal?.querySelector('video');
        const videoModalContent = videoModal?.querySelector('.video-modal-content') as HTMLDivElement;

        if (videoModal && videoModalContent) {
            console.log('videoModal', videoModal);

            videoModal.style.display = 'block';
            videoModal.style.opacity = '1';
            videoModalContent.style.opacity = '0';
            videoModalContent.style.transform = 'translate(-50%, -50%) scale(0.5)';
            videoModalContent.style.transition = 'opacity 1s ease, transform 1s ease';
            setTimeout(() => {
                videoModalContent.style.opacity = '1';
                videoModalContent.style.transform = 'translate(-50%, -50%) scale(1)';
            }, 10);
            document.body.style.overflow = 'hidden';
            if (videoElement) {
                setCurrentVideo(videoSrc);
                videoElement.src = videoSrc;
                videoElement.play();
            }
            setIsModalOpen(true);
        }
    };

    const handleCloseModal = () => {
        const videoModal = document.getElementById('usaVideoModal');
        const videoElement = videoModal?.querySelector('video');
        const videoModalContent = videoModal?.querySelector('.video-modal-content') as HTMLDivElement;

        if (videoModal && videoModalContent) {
            videoModalContent.style.transition = 'opacity 0.5s ease, transform 0.5s ease';
            videoModalContent.style.opacity = '0';
            videoModalContent.style.transform = 'translate(-50%, -50%) scale(0.5)';
            setTimeout(() => {
                videoModal.style.opacity = '0';
                setTimeout(() => {
                    videoModal.style.display = 'none';
                    document.body.style.overflow = '';
                    if (videoElement) videoElement.pause();
                }, 500);
            }, 0);
        }
    };

    useEffect(() => {
        setIsModalOpen(true);
    }, [handleClick]);

    return (
        <>
            <BorderEdge color="text-green-500 dark:text-black" isTop={true} />
            <div className="section section-py dark:bg-black dark:pt-0 overflow-x-hidden bg-green-500">
                <div className="container xl:container mx-auto px-4">
                    <div className="row grid lg:grid-cols-12 text-center">
                        <div className="lg:col-span-12 gap-4 grid pb-2.5">
                            <h2 className="text-primary text-center">Why 500+ Global Clients Trust Moweb</h2>
                            <div className="text-white fw-700 mb-7">Exceeding Expectations, Delivering Excellence</div>
                        </div>
                    </div>

                    {isModalOpen && (
                        <div id="usaVideoModal" className="video-modal">
                            <div className="video-modal-content">
                                <a onClick={handleCloseModal} className="close-modal cursor-pointer">
                                    <Image
                                        src="img/odoo/close.svg"
                                        width={24}
                                        height={24}
                                        alt="Close"
                                        className="close-modal-icon"
                                        onClick={handleCloseModal}
                                    />
                                </a>
                                <video controls>
                                    <source src={currentVideo} type="video/mp4" />
                                </video>
                            </div>
                        </div>
                    )}

                    {testimonialData.length > 0 && (
                        <div className="section pb-16 dark:bg-black case-study-slider-img testimonial-slider-img">
                            <div className="container-fluid lg:container-fluid mx-auto">
                                <Slider {...testimonialsettings} data-aos="fade-up" data-aos-duration="2000" data-aos-delay="500">
                                    {testimonialData.map((testimonial: any) => (
                                        <div key={testimonial.id} className="cursor-pointer">
                                            <TestimonialsCarouselItem
                                                path={testimonial?.image}
                                                alt={testimonial.client_name}
                                                height={400}
                                                width={630}
                                                data={testimonial?.description || '-'}
                                                name={testimonial?.project_name || '-'}
                                                post={testimonial?.client_name || '-'}
                                                link="/"
                                                testimonialvideo={testimonial?.video}
                                                handleClick={handleClick}
                                            />
                                        </div>
                                    ))}
                                </Slider>
                            </div>
                        </div>
                    )}
                </div>
            </div>
            <BorderEdge color="text-white dark:text-black" isTop={true} bg="bg-green-500 dark:bg-black" />
        </>
    );
};

export default UsaClientTrust;
